import { getIn, useFormikContext } from "formik";
import { ObjectSchema } from "models/utilTypes/yupSchemaTypes";
import * as Yup from "yup";

function useCheckRequired(validationSchema?: ObjectSchema<any>) {
  const { values } = useFormikContext<any>();

  const getFieldRequired = (name: string, tableRowField?: string): boolean => {
    if (!validationSchema) return false;

    const describeObj = validationSchema.describe({ value: values });
    const fieldValidationDescription = describeObj.fields[name];

    const getIsRequiredFromDescription = (fieldValidationDescription: Yup.SchemaFieldDescription) => {
      const optional =
        fieldValidationDescription && "optional" in fieldValidationDescription
          ? fieldValidationDescription.optional
          : true;

      const hasRequiredTest =
        fieldValidationDescription && "tests" in fieldValidationDescription
          ? !!fieldValidationDescription.tests.find((test: any) => test.name === "required")
          : false;

      return !optional || hasRequiredTest;
    };

    if (fieldValidationDescription === undefined) {
      let fieldValidationSchema: Yup.Schema<any>;
      try {
        fieldValidationSchema = Yup.reach(validationSchema, name, values, values) as Yup.Schema<any>;
        if (fieldValidationSchema === undefined) return false;

        const conditions = (fieldValidationSchema as any).conditions;
        if (conditions && conditions.length > 0) {
          try {
            return conditions.some((condition: any) => {
              const conditionalValidationSchema =
                condition.fn && condition.refs
                  ? condition.fn(
                      condition.refs.map((ref: any) => {
                        return getIn(values, `${tableRowField ? `${tableRowField}.` : ""}${ref.key}`);
                      }),
                      fieldValidationSchema
                    )
                  : false;
              const conditionalSchemaDescription = conditionalValidationSchema.describe();
              return getIsRequiredFromDescription(conditionalSchemaDescription);
            });
          } catch {
            return false;
          }
        } else {
          const fieldValidationSchemaDescription = fieldValidationSchema.describe();
          return getIsRequiredFromDescription(fieldValidationSchemaDescription);
        }
      } catch {
        return false;
      }
    } else {
      return getIsRequiredFromDescription(fieldValidationDescription);
    }
  };

  return {
    getFieldRequired,
  };
}

export default useCheckRequired;
